module.exports = __webpack_public_path__ + "media/Video 28b.cd2df1a8.mp4";